<template>
  <div class="pdt-20px column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('editionFacture.generalTitle.ChangeProduits')}}
        </p>
      </header>
      <div class="card-content">
        <app-liste-vente :dcf="factureDetail" />
      </div>
    </div>
  </div>
</template>

<script>
import appListeVente from './ligneFactureModifProduit/listeLignesVentesModificationProduit';

export default {
  props: {
    factureDetail: Object,
  },
  components: {
    appListeVente,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped>

</style>
